import { lazy } from 'react'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'

const Inner = lazy(() => import('./Inner'))

/**
 * Component that hosts the opportunity dialogs that may be invoked from
 * anywhere else in the app.
 */
export const OpportunityDialogsHost = observer(
  function OpportunityDialogsHost() {
    const { isOpportunitiesRequested } = useFeatures((r) => ({
      isOpportunitiesRequested: r.opportunities.internal.isRequested,
    }))

    // Rendering the dialogs loads the feature, so wait until something else has.
    if (!isOpportunitiesRequested()) {
      return null
    }

    return <Inner />
  },
)
